import { makeActionCreator } from '../../../utilities'
import { ApiErrorHandlerConstants } from './apiErrorHandler.constants'

export const resetApiErrorHandler = makeActionCreator(ApiErrorHandlerConstants.RESET_API_ERROR_HANDLER)
export const showAlert = makeActionCreator(ApiErrorHandlerConstants.SHOW_ALERT, 'showAlert')
export const showToast = makeActionCreator(ApiErrorHandlerConstants.SHOW_TOAST, 'showToast')
export const handleApiError = makeActionCreator(ApiErrorHandlerConstants.HANDLE_API_ERROR, 'error')
export const setErrorMessage = makeActionCreator(ApiErrorHandlerConstants.SET_ERROR_MESSAGE, 'errorMessage')
export const setCallback = makeActionCreator(ApiErrorHandlerConstants.SET_CALLBACK, 'callback')
export const setButtons = makeActionCreator(ApiErrorHandlerConstants.SET_BUTTONS, 'buttons')
export const setHeader = makeActionCreator(ApiErrorHandlerConstants.SET_HEADER, 'header')
export const setErrorToastDuration = makeActionCreator(
  ApiErrorHandlerConstants.SET_ERROR_TOAST_DURATION,
  'errorToastDuration'
)
